import React, { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { toast } from "react-hot-toast"; 
import "./CreateEvent.css";
import { endpoints } from "../../services/operations/api"; 

const CreateEvent = () => {
  const [formData, setFormData] = useState({
    eventName: "",
    description: "",
    date: "",
    location: "",
    maxAttendees: "",
  });
  const [loading, setLoading] = useState(false); 

  const { eventName, description, date, location, maxAttendees } = formData;

  const handleInputChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formDataToSend = {
      name: eventName,
      description: description,
      date: date,
      location: location,
      maxAttendees: maxAttendees,
    };

    try {
      setLoading(true); 
      const token = JSON.parse(localStorage.getItem("token")); 

      const response = await axios.post(endpoints.CREATE_EVENT_API, formDataToSend, {
        headers: {
          Authorization: `Bearer ${token}`, 
          "Content-Type": "application/json", 
        },
      });

      if (response.data.success) {
        toast.success("Event created successfully!");
        setFormData({
          eventName: "",
          description: "",
          date: "",
          location: "",
          maxAttendees: "",
        });
      } else {
        toast.error(response.data.message || "Failed to create event.");
      }
    } catch (error) {
      console.error("Error creating event:", error);
      toast.error(error.response?.data?.message || "Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="create-event-container">
      <div className="event-card">
        <h1 className="event-title">Create Event</h1>
        <form onSubmit={handleSubmit} className="create-event-form">
          <div className="form-group">
            <label htmlFor="eventName">Event Name</label>
            <input
              type="text"
              id="eventName"
              name="eventName"
              placeholder="Enter event name"
              value={eventName}
              onChange={handleInputChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="description">Description</label>
            <textarea
              id="description"
              name="description"
              placeholder="Enter event description"
              value={description}
              onChange={handleInputChange}
              required
            ></textarea>
          </div>
          <div className="form-group">
            <label htmlFor="date">Date</label>
            <input
              type="date"
              id="date"
              name="date"
              value={date}
              onChange={handleInputChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="location">Location</label>
            <input
              type="text"
              id="location"
              name="location"
              placeholder="Enter event location"
              value={location}
              onChange={handleInputChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="maxAttendees">Max Attendees</label>
            <input
              type="number"
              id="maxAttendees"
              name="maxAttendees"
              placeholder="Enter max attendees"
              value={maxAttendees}
              onChange={handleInputChange}
              required
            />
          </div>
          <div className="event-actions">
            <button type="submit" className="create-button" disabled={loading}>
              {loading ? "Creating Event..." : "Create Event"}
            </button>
            <Link to="/dashboard" className="cancel-button">
              Cancel
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateEvent;
